import { UICtx } from '@frontend/sorghum/external-providers';
import { BREAK_POINT, useRwd } from '@frontend/sorghum/utils';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';
import { FC, useContext } from 'react';

interface MobileMenuButtonProps {
  // 額外的 sx 微調（例如各頁標題列對齊用）
  sx?: object;
}

// 手機才顯示的漢堡鈕，點了打開外殼側欄 overlay。
// 設計成「內嵌」用：放在各頁標題列的最左邊，跟標題同一排（桌機 isMobile=false 不顯示）。
export const MobileMenuButton: FC<MobileMenuButtonProps> = ({ sx }) => {
  const { breakPoint } = useRwd();
  const isMobile = breakPoint < BREAK_POINT.MD;
  const { setIsOpenLeftSidebar } = useContext(UICtx);

  if (!isMobile) return null;

  return (
    <IconButton
      aria-label="open navigation"
      onClick={() => setIsOpenLeftSidebar(true)}
      sx={{ ml: '-8px', mr: '4px', flexShrink: 0, ...sx }}
    >
      <MenuIcon sx={{ color: 'grey.800' }} />
    </IconButton>
  );
};

export default MobileMenuButton;
